import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


const HomeContent = () => {
    return (
            <div className="rn-splite-style">
                <div className="split-wrapper">
                        <div className="row no-gutters radius-10 align-items-center">
                            
                            <div className="col-lg-12 col-xl-6 col-12">
                                <div className="split-inner">
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <h4 className="title">Content Outcomes:</h4>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <p className="description"></p>
                                    </ScrollAnimation>

                                    
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <ol className="">
                                            <li>3X Faster Learning</li>
                                            <li>5-Minute Daily Watch Plan</li>
                                            <li>Actionable content across 20+ sectors—from marketing and sales to mindset and business systems.</li>
                                            <li>Experts Insights.</li>
                                            <li>1,000+ Minutes of Content Available.</li>
                                            <li>24/7 Access Across Devices.</li>
                                        </ol>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <div className="view-more-button mt--35">
                                            <Link className="btn-default" to="/content">LEARN MORE</Link>
                                        </div>
                                    </ScrollAnimation>
                                </div>
                        </div>
                        <div className="col-lg-12 col-xl-6 col-12">
                                <div className="thumbnail image-left-content">
                                    <img src="./images/content.jpg" alt="split Images" />
                                </div>
                            </div>
                    </div>
                </div>
            </div>
    )
}

export default HomeContent
